import React, { useState } from 'react';
import './Skills.css';
import portfolioData from '../data/portfolio.json';

const Skills = () => {
  const { technologies, coreCompetencies } = portfolioData;

  return (
    <section id="skills" className="skills">
      <h2>Skills & Technologies</h2>
      
      <div className="skills-container">
        <div className="core-competencies">
          <h3 className="section-subtitle">Core Competencies</h3>
          <div className="competencies-grid">
            {coreCompetencies.map((competency, index) => (
              <div key={index} className="competency-card">
                <svg className="card-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <div className="card-text">{competency}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="technologies">
          <h3 className="section-subtitle">Technologies</h3>
          <div className="tech-categories-grid">
            {Object.entries(technologies).map(([category, items]) => (
              <div key={category} className="tech-category">
                <h4 className="category-title">
                  {category.replace(/([A-Z])/g, ' $1').trim().toUpperCase()}
                </h4>
                <div className="tech-items">
                  {items.map((item, index) => (
                    <span key={index} className="tech-tag">
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
